import { Affix, Alert, Button } from 'antd'

export default function TopAlert(props: { id?: number; hide: boolean }) {
  const { id, hide } = props
  const Content = () => {
    if (id === 1) {
      return (
        <Alert
          icon="🎉"
          type="error"
          message={
            <p>
              <strong>「我想对你说」</strong>
              粉丝反馈征集活动，🎁 有机会在首页上榜或者获得随机红包或者店铺惊喜优惠券 👉 👉{' '}
              <Button type="link" href="https://httishere666.notion.site/1316018c38ee803fb09ade8371f953ff?pvs=105" target="_blank">
                <strong className="text-rose-800 underline">✍️ 写下你想对我说的话吧～</strong>
              </Button>
            </p>
          }
          banner
        />
      )
    }
    return <></>
  }
  if (hide) return <></>
  return (
    <Affix offsetTop={70}>
      <Content />
    </Affix>
  )
}
